var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{ref:"inputRef",staticClass:"input-field",attrs:{"type":"text","label":_vm.label,"value":_vm.value,"disabled":_vm.disabled,"required":"","outlined":"","dense":"","color":"black","rules":_vm.rules}})}
var staticRenderFns = []

export { render, staticRenderFns }